import { jsx as r, Fragment as u } from "react/jsx-runtime";
import { createContext as c, useContext as d, useMemo as C } from "react";
import { getApiClient as e } from "./index.es267.js";
const s = c({
  apiClient: e({ token: "", environment: "production" }).apiClient,
  token: "",
  environment: "production",
  endpoints: e({ token: "", environment: "production" }).endpoints
}), l = ({
  token: t = "",
  environment: o = "production",
  children: n
}) => {
  const { apiClient: i, endpoints: p } = C(() => e({
    token: t,
    environment: o
  }), [t, o]);
  return !t || !o ? /* @__PURE__ */ r(u, { children: n }) : /* @__PURE__ */ r(
    s.Provider,
    {
      value: {
        token: t,
        environment: o,
        apiClient: i,
        endpoints: p
      },
      children: i && n
    }
  );
}, P = () => {
  const t = d(s);
  return (!t || t.token === "") && console.warn("API Context must be initialized before using useAPI hook"), t;
};
export {
  l as APIContextProvider,
  P as useAPIContext
};
//# sourceMappingURL=index.es46.js.map
